import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Upload, Checkbox, Select } from 'antd';
import PropTypes from 'prop-types';
import { PlusOutlined } from '@ant-design/icons';
import constants from '@Apis/constants';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import H3ImageSelectorWithCrop from '../../../../uilib/H3ImageSelectorWithCrop';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class ViewOrgAdmin extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      fileList: [],
      uploadButton: (
        <div>
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>

        </div>
      ),
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getOrg, user } = this.props;
    getOrg(user?.tenant_info?.org_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.org?.organisation?.[0]?.org_id && !state.isUserReady) {
      const { org } = props;
      return {
        ...state,
        isUserReady: true,
        organisationName: org?.organisation?.[0]?.organisation_name,
        fileList: org?.organisation?.[0]?.logo ? [{ url: org?.organisation?.[0]?.logo }] : [],
        currencyCode: org?.organisation?.[0]?.currency_code,
        org: props.org,
        inventoryConfig: org?.organisation?.[0]?.inventory_config,
        globalConfig: org?.organisation?.[0]?.global_config,
        purchaseConfig: org?.organisation?.[0]?.purchase_config,
        quantityPrecision: org?.organisation?.[0]?.inventory_config?.settings?.quantity_precision,
        pricePrecision: org?.organisation?.[0]?.global_config?.settings?.price_precision,
        transactionDateFormat: org?.organisation?.[0]?.global_config?.settings?.transaction_date_format,
        createdModifiedDateFormat: org?.organisation?.[0]?.global_config?.settings?.created_modified_date_format,
        negativeInventory: !!org?.organisation?.[0]?.inventory_config?.settings?.negative_inventory_allowed,
        excessGrnQty: !!org?.organisation?.[0]?.purchase_config?.sub_modules?.goods_receiving_note?.settings?.flexible_qty_wrt_po,
        poExpiryDays: org?.organisation?.[0]?.purchase_config?.sub_modules?.purchase_order?.settings?.default_po_expiry_days,
        enableTdsTcs: org?.organisation?.[0]?.global_config?.settings?.enable_tds_tcs,
        autoPrintDescription: org?.organisation?.[0]?.global_config?.settings?.print_description_automatically,
      };
    }
    return state;
  }

  /**
   *
   * @param {*} param0
   * @return
   */
  handleChange = ({ fileList }) => this.setState({ fileList });

  /**
   *
   */
  handleUpdateProfile() {
    const {
      user, updateOrg, getOrg, getUserProfile,
    } = this.props;
    const {
      organisationName, fileList, quantityPrecision, pricePrecision, enableTdsTcs, autoPrintDescription,
      negativeInventory, excessGrnQty, poExpiryDays, inventoryConfig, globalConfig, purchaseConfig, createdModifiedDateFormat, transactionDateFormat,
    } = this.state;
    this.setState({ formSubmitted: true });
    if (organisationName) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        organisation_name: organisationName,
        logo: fileList[0]?.response?.response?.location
          ? fileList[0]?.response?.response?.location
          : (fileList[0]?.url ? fileList[0]?.url : ''),
        inventory_config: {
          ...inventoryConfig,
          settings: {
            ...inventoryConfig?.settings,
            quantity_precision: quantityPrecision,
          },
        },
        global_config: {
          ...globalConfig,
          settings: {
            ...globalConfig.settings,
            price_precision: pricePrecision,
            created_modified_date_format: createdModifiedDateFormat,
            transaction_date_format: transactionDateFormat,
            enable_tds_tcs: enableTdsTcs,
            print_description_automatically: autoPrintDescription,
          },
        },
        purchase_config: {
          ...purchaseConfig,
          sub_modules: {
            ...purchaseConfig.sub_modules,
            goods_receiving_note: {
              ...purchaseConfig.sub_modules.goods_receiving_note,
              settings: {
                ...purchaseConfig.sub_modules.goods_receiving_note.settings,
                flexible_qty_wrt_po: excessGrnQty,
              },
            },
            purchase_order: {
              ...purchaseConfig.sub_modules.purchase_order,
              settings: {
                ...purchaseConfig.sub_modules.purchase_order.settings,
                default_po_expiry_days: poExpiryDays,
              },
            },
          },
        },
      };
      updateOrg(payload, () => {
        getOrg(user?.tenant_info?.org_id);
        getUserProfile();
      });
    }
  }

  /**
   *
   * @return
   */
  render() {
    const {
      updateOrgLoading, getOrgLoading,
    } = this.props;
    const {
      formSubmitted, fileList, uploadButton, organisationName, currencyCode, config, quantityPrecision, pricePrecision,
      negativeInventory, excessGrnQty, poExpiryDays, enableTdsTcs, autoPrintDescription, transactionDateFormat, createdModifiedDateFormat,
    } = this.state;

    const transactionDateFormats = [
      { name: "YYYY-DD-MM", value: "YYYY-DD-MM" },
      { name: "YYYY/DD/MM", value: "YYYY/DD/MM" },
      { name: "MM-DD-YYYY", value: "MM-DD-YYYY" },
      { name: "MM/DD/YYYY", value: "MM/DD/YYYY" },
      { name: "DD-MM-YYYY", value: "DD-MM-YYYY" },
      { name: "DD/MM/YYYY", value: "DD/MM/YYYY" },
      { name: "YY-DD-MM", value: "YY-DD-MM" },
      { name: "YY/DD/MM", value: "YY/DD/MM" },
      { name: "MM-DD-YY", value: "MM-DD-YY" },
      { name: "MM/DD/YY", value: "MM/DD/YY" },
      { name: "DD-MM-YY", value: "DD-MM-YY" },
      { name: "DD/MM/YY", value: "DD/MM/YY" }
    ];
  
    const createdModifiedDateFormats = [
      ...transactionDateFormats,
      { name: "YYYY-DD-MM HH:mm:ss", value: "YYYY-DD-MM HH:mm:ss" },
      { name: "YYYY/DD/MM HH:mm:ss", value: "YYYY/DD/MM HH:mm:ss" },
      { name: "YYYY-DD-MM hh:mm AM/PM", value: "YYYY-DD-MM hh:mm AM/PM" },
      { name: "YYYY/DD/MM hh:mm AM/PM", value: "YYYY/DD/MM hh:mm AM/PM" },
      { name: "MM-DD-YYYY HH:mm:ss", value: "MM-DD-YYYY HH:mm:ss" },
      { name: "MM/DD/YYYY HH:mm:ss", value: "MM/DD/YYYY HH:mm:ss" },
      { name: "MM-DD-YYYY hh:mm AM/PM", value: "MM-DD-YYYY hh:mm AM/PM" },
      { name: "MM/DD/YYYY hh:mm AM/PM", value: "MM/DD/YYYY hh:mm AM/PM" },
      { name: "DD-MM-YYYY HH:mm:ss", value: "DD-MM-YYYY HH:mm:ss" },
      { name: "DD/MM/YYYY HH:mm:ss", value: "DD/MM/YYYY HH:mm:ss" },
      { name: "DD-MM-YYYY hh:mm AM/PM", value: "DD-MM-YYYY hh:mm AM/PM" },
      { name: "DD/MM/YYYY hh:mm AM/PM", value: "DD/MM/YYYY hh:mm AM/PM" },
      { name: "YY-DD-MM HH:mm:ss", value: "YY-DD-MM HH:mm:ss" },
      { name: "YY/DD/MM HH:mm:ss", value: "YY/DD/MM HH:mm:ss" },
      { name: "YY-DD-MM hh:mm AM/PM", value: "YY-DD-MM hh:mm AM/PM" },
      { name: "YY/DD/MM hh:mm AM/PM", value: "YY/DD/MM hh:mm AM/PM" },
      { name: "MM-DD-YY HH:mm:ss", value: "MM-DD-YY HH:mm:ss" },
      { name: "MM/DD/YY HH:mm:ss", value: "MM/DD/YY HH:mm:ss" },
      { name: "MM-DD-YY hh:mm AM/PM", value: "MM-DD-YY hh:mm AM/PM" },
      { name: "MM/DD/YY hh:mm AM/PM", value: "MM/DD/YY hh:mm AM/PM" },
      { name: "DD-MM-YY HH:mm:ss", value: "DD-MM-YY HH:mm:ss" },
      { name: "DD/MM/YY HH:mm:ss", value: "DD/MM/YY HH:mm:ss" },
      { name: "DD-MM-YY hh:mm AM/PM", value: "DD-MM-YY hh:mm AM/PM" },
      { name: "DD/MM/YY hh:mm AM/PM", value: "DD/MM/YY hh:mm AM/PM" }
    ];
  
  

    return (
      <Fragment>
        <div className="organisation-wrapper-outer">
          <div className="ant-col-md-18">
            <div className="organisation-wrapper">
              <div className="ant-row">

                <div className="ant-col-md-12">
                  <H3FormInput
                    name="a valid Organisation Name"
                    type="text"
                    containerClassName="orgInputContainer"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(event) => this.setState(
                      { organisationName: event.target.value },
                    )}
                    value={organisationName}
                    required
                    disabled={updateOrgLoading || getOrgLoading}
                    showError={formSubmitted && !organisationName}
                    label="Organisation Name"
                  />
                </div>
                <div className="ant-col-md-12" />

                <div className="ant-col-md-12">
                  <div className="orgInputContainer  profile__right-input">
                    <label className="orgFormLabel">
                      Your Logo
                    </label>
                    <div className="ant-col-md-12">
                        <div className="settings__profile-wrapper-img">

                          <H3ImageSelectorWithCrop>
                            <Upload
                              action={constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={this.handleChange}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList?.length >= 1 ? null
                                : uploadButton}
                            </Upload>
                          </H3ImageSelectorWithCrop>
                        </div>
                      </div>
                  </div>
                </div>
                <div className="ant-col-md-12" />
                <DateFormatDropdown label="Date Format for Transactions" options={transactionDateFormats} disabled={updateOrgLoading || getOrgLoading} value={transactionDateFormat} onChange={(value) => this.setState({ transactionDateFormat: value })}/>
                <div className="ant-col-md-12" />
                <DateFormatDropdown label="Date Format for Created At & Modified At" options={createdModifiedDateFormats} disabled={updateOrgLoading || getOrgLoading} value={createdModifiedDateFormat} onChange={(value) => this.setState({ createdModifiedDateFormat: value })}/>
                <div className="ant-col-md-12" />
                <div className="ant-col-md-12">
                  <div className="orgInputContainer">
                    <div className="orgFormLabel">Price Precision</div>
                    <PRZSelect
                      value={pricePrecision}
                      onChange={(value) => {
                        this.setState({ pricePrecision: value });
                      }}
                      disabled={updateOrgLoading || getOrgLoading}
                    >
                      {[1, 2, 3, 4, 5].map((item) => <Option key={item} label={item} value={item}>{item}</Option>)}
                    </PRZSelect>
                  </div>
                </div>
                <div className="ant-col-md-12" />
                
                {/* <div className="ant-col-md-12">
                  <div className="organisation__currency orgInputContainer">
                    <Checkbox disabled={updateOrgLoading || getOrgLoading} checked={negativeInventory} onChange={() => this.setState({ negativeInventory: !negativeInventory })} />
                    &nbsp;&nbsp;
                    <H3Text text="Allow Negative Inventory " className="organisation__currency-label" />
                  </div>
                </div> */}
                {/* <div className="ant-col-md-12" /> */}

                <div className="ant-col-md-12">
                  <div className="organisation__currency orgInputContainer">
                    <Checkbox disabled={updateOrgLoading || getOrgLoading} checked={excessGrnQty} onChange={() => this.setState({ excessGrnQty: !excessGrnQty })} />
                    &nbsp;&nbsp;
                    <H3Text text="Allow GRN quantity to be more then purchase orders" className="organisation__currency-label" />
                  </div>
                </div>
                <div className="ant-col-md-12" />

                <div className="ant-col-md-12">
                  <div className="organisation__currency orgInputContainer">
                    <Checkbox disabled={updateOrgLoading || getOrgLoading} checked={enableTdsTcs} onChange={() => this.setState({ enableTdsTcs: !enableTdsTcs })} />
                    &nbsp;&nbsp;
                    <H3Text text="Enable TDS/TCS inputs in all transactions" className="organisation__currency-label" />
                  </div>
                </div>
                <div className="ant-col-md-12" />

                <div className="ant-col-md-12">
                  <div className="organisation__currency orgInputContainer">
                    <Checkbox disabled={updateOrgLoading || getOrgLoading} checked={autoPrintDescription} onChange={() => this.setState({ autoPrintDescription: !autoPrintDescription })} />
    &nbsp;&nbsp;
                    <H3Text text="Print product description by default in all documents" className="organisation__currency-label" />
                  </div>
                </div>
                <div className="ant-col-md-12" />
                <div className="ant-col-md-12">
                  <div className="organisation__currency">
                    <H3Text text="Default Currency - " className="organisation__currency-label" />
                    <H3Text text={currencyCode} className="organisation__currency-value" />
                  </div>
                </div>
                <div className="ant-col-md-12" />

                <div className="ant-col-md-12">
                  <H3Button
                    text="Save"
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    customClass="organisation-submit"
                    onClick={() => {
                      this.handleUpdateProfile();
                    }}
                    isLoading={updateOrgLoading || getOrgLoading}
                    disabled={updateOrgLoading || getOrgLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const DateFormatDropdown = ({ label, options, value, onChange, disabled }) => {
  return (
      <div className="ant-col-md-12">
          <div className="orgInputContainer">
              <div className="orgFormLabel">{label}</div>
              <PRZSelect
                  value={value}
                  onChange={onChange}
                  disabled={disabled}
              >
                  {options.map((option) => (
                      <Option key={option.value} value={option.value}>
                          {option.name}
                      </Option>
                  ))}
              </PRZSelect>
          </div>
      </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  updateOrgLoading: UserReducers.updateOrgLoading,
  org: UserReducers.org,
  getOrgLoading: UserReducers.getOrgLoading,
});
const mapDispatchToProps = (dispatch) => ({
  updateOrg: (payload, callback) => dispatch(UserActions.updateOrg(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),

});

ViewOrgAdmin.propTypes = {
  user: PropTypes.object,
  updateOrg: PropTypes.func,
  updateOrgLoading: PropTypes.bool,
  getOrgLoading: PropTypes.bool,
  getOrg: PropTypes.func,
  org: PropTypes.any,
  getUserProfile: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewOrgAdmin));
